import { Button, ButtonProps } from '@mui/material';
import { TEXTS } from '../../core/texts';

export const CancelButton = (props?: ButtonProps) => (
  <Button variant={'outlined'} color={'error'} {...props}>{TEXTS.CANCEL}</Button>);